import React, { useState } from 'react';
import AdminLayout from '../../components/admin/layout/AdminLayout';
import AnalyticsOverview from '../../components/admin/analytics/AnalyticsOverview';
import { FiBarChart2 } from 'react-icons/fi';

const AnalyticsDashboard: React.FC = () => {
  const [dateRange, setDateRange] = useState('7d');

  const breadcrumbs = [
    { label: 'สถิติและรายงาน', icon: FiBarChart2 }
  ];

  const handleDateRangeChange = (range: string) => {
    setDateRange(range);
    // Here you would typically trigger an API call to fetch new data
    console.log('Date range changed to:', range);
  };

  return (
    <AdminLayout
      title="สถิติและรายงาน"
      breadcrumbs={breadcrumbs}
    >
      <div className="space-y-8">
        {/* Analytics Overview */}
        <AnalyticsOverview
          dateRange={dateRange}
          onDateRangeChange={handleDateRangeChange}
        />

        {/* Additional Analytics Sections can be added here */}
        {/* For example: User Demographics, Traffic Sources, Performance Metrics, etc. */}
      </div>
    </AdminLayout>
  );
};

export default AnalyticsDashboard;